/******************************************************************************************
 *  Currency Formatter Filter
 *******************************************************************************************
 *
 * Uses Angular's currency filter, but with removal of decimal after
 * standard currency formatting.
 *
 * Later versions of Angular's currency filter allow for this, so if we update to Angular 1.3
 * or greater, we can remove this custom filter.
 *
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.currencyFormatter', []).filter(
    'currencyFormatter',
    /* @ngInject */
    function(_, $locale, $filter) {
      var formats = $locale.NUMBER_FORMATS;
      return function(amount, currencySymbol, fractionSize) {
        if (_.isUndefined(currencySymbol)) {
          currencySymbol = formats.CURRENCY_SYM;
        }

        var currencyFormatted = $filter('currency')(amount, currencySymbol);
        if (fractionSize === 0 && _.includes(currencyFormatted, formats.DECIMAL_SEP)) {
          // remove any fractions from the formatted currency string. The angular 1.2 version of the currency
          // filter hardcodes 2 decimal places, so we'll remove just the decimal separator plus those two
          // numerals in order to work with currency symbols that come after the value.
          currencyFormatted = _.replace(
            currencyFormatted,
            new RegExp('\\' + formats.DECIMAL_SEP + '\\d{2}'),
            ''
          );
        }
        return currencyFormatted;
      };
    }
  );
})();
